module.exports = __webpack_public_path__ + "static/media/02-13.76606e8f.png";